import { render, staticRenderFns } from "./witness_participated.vue?vue&type=template&id=b9256fbc&"
import script from "./witness_participated.vue?vue&type=script&lang=js&"
export * from "./witness_participated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports